import { useEffect, useState } from 'react';
import { Dropdown, DropdownChangeEvent } from '../../Common/Imports';
import { DDModel } from '../../Models/Classes';
import { ContactType } from '../../Models/Enums';


interface DDPropertyContactsProps {
    value?: number | undefined,
    onSelect?: (type: number) => void;
}


export const DDStakeholderType: React.FC<DDPropertyContactsProps> = ({ onSelect, value }) => {
    const [data] = useState<DDModel<number>[]>([{
        label: "Customer",
        id: 0,
        data: 0
    },
    {
        label: "Provider",
        id: 1,
        data: 1
    }]);
    const [selectedElem, setSelectedElem] = useState<DDModel<ContactType> | undefined>();

    useEffect(() => {
        if (value || value === 0) {
            setSelectedElem(data.filter((m: DDModel<number>) => m.data == value)[0])
        }
    }, [data, selectedElem, value]);

    const handleChange = (e: DropdownChangeEvent) => {
        const _val = e.value as DDModel<ContactType> | undefined;
        setSelectedElem(_val);
        if (onSelect && e) {
            onSelect(e.value.data);
        }
    };
    return (
        <Dropdown
            value={selectedElem}
            onChange={handleChange}
            options={data}
            optionLabel="label" />
    );
};
